<template>
  <div id="instruction">
    <div class="nav-close" @click="closeInstruction(room)"><div class="m-btn__cross"></div></div>
    <h4>{{ room | capitalize }}</h4>
    <p>Click and drag to move round the room and find the question mark hotspots.</p>
    <!--<div class="nav-close-btn" @click="closeInstruction(room)">
      <div class="m-btn__cross"></div>
      <span>&nbsp; Close</span>
    </div>-->
  </div>
</template>

<script>
import { mapActions } from 'vuex'
export default {
  props: ['room'],
  methods: {
    ...mapActions(['updateInstruction']),
    closeInstruction (roomName) {
      this.updateInstruction(roomName)
    }
  },
  name: 'Instruction'
}
</script>

<style scoped lang="scss">

h4 {
  margin:15px 0;
}

p {
  font-size:140%;
}

.m-btn__cross {
  float:right;
}
.nav-close {
  cursor: pointer;
}

.nav-close-btn {
  position:absolute;
  bottom:0;
  background: #fff;
  color:#000;
  width:18%;
  border-radius: 0px;
  box-shadow: 0px 0px 10px rgba(0,0,0,0.16);
  padding:8px 5px 10px 15px;
  cursor: pointer;
  // &:hover {
  //   background: $color-primary;
  // }
  // &.disabled {
  //     cursor: not-allowed;
  //     background-color: $color-lightgrey;
  // }
}

.nav-close-btn .m-btn__cross {
  float:none;
  display:inline-block;
  transform:translateY(6px);
}
</style>



// WEBPACK FOOTER //
// src/components/Instruction.vue